module.exports = __webpack_public_path__ + "img/expand.e34d066d.svg";